// extracted by mini-css-extract-plugin
module.exports = {"lia-text-link-wrap":"AuthenticationModal_lia-text-link-wrap__GkD3L","lia-modal-title":"AuthenticationModal_lia-modal-title__cUFwy"};